module.exports = __webpack_public_path__ + "static/media/library.f6cb566a.jpg";